import LndButton from '@components/LndButton';
import { useAuth } from '@contexts/AuthContext';
import { MasqueradeUser } from '@customTypes/auth/Auth';
import LocalStorageKey from '@enums/LocalStorageKey';
import SessionStorageService from '@services/SessionStorageService';
import { queryClient } from '../../libs/queryClient';
import React from 'react';
import { useNavigate } from 'react-router';
import styles from './styles.module.scss';

interface MasqueradeActiveSessionProps {
  user: MasqueradeUser;
}

// Fixed pill used on the sidebar-less pages (onboarding / auth-callback). While
// the sidebar is present, the masquerade controls live in the UserPanel menu.
const MasqueradeActiveSession: React.FC<MasqueradeActiveSessionProps> = ({
  user,
}: MasqueradeActiveSessionProps) => {
  const { setMasqueradeLogin, isMasquerading } = useAuth();
  const navigate = useNavigate();

  const stopMasquerading = () => {
    // Masquerade lives per-tab in sessionStorage; removing it here only
    // affects THIS tab, matching the isolation model.
    SessionStorageService.removeItem(LocalStorageKey.MASQUERADE_USER);
    SessionStorageService.removeItem(LocalStorageKey.MASQUERADE_OPERATOR_EMAIL);
    // Clear React Query cache when stopping masquerading to prevent showing masqueraded user's data
    queryClient.clear();
    setMasqueradeLogin(null);
    window.location.href = '/';
  };

  // Open the picker WITHOUT ending the current masquerade — the operator stays
  // impersonating until they pick a new user, which swaps the session directly.
  const switchMasquerade = () => navigate('/masquerade');

  return (
    <div className={`${styles.MasqueradeWrapper}`}>
      <div className={`${styles.MasqueradeContainer}`}>
        <div className='text-xs font-semibold'>
          You are now masquerading as <strong>{user?.name}</strong>
        </div>
        <LndButton
          onClick={switchMasquerade}
          loading={isMasquerading}
          className='!p-[7px] !h-[27px] !text-xs'
        >
          Switch User
        </LndButton>
        <LndButton
          variant="danger"
          onClick={stopMasquerading}
          loading={isMasquerading}
          className='!p-[7px] !h-[27px] !text-xs'
        >
          Stop Masquerading
        </LndButton>
      </div>
    </div>
  );
};

export default MasqueradeActiveSession;
